/**
 * @prettier
 * @flow
 */
import * as React from 'react';
import { FormSelect } from 'src/components/form/FormSelect';
import type { Variant } from 'src/components/form/FormTypes';
import { translate } from 'src/utils/translate/translate';

const Msi = Object.freeze({
    '3': '3',
    '6': '6',
    '9': '9',
    '12': '12',
    '18': '18',
});

export function FormMsiSelect({ name, label, placeholder, helperText, defaultValue, disabled, required, variant = 'outlined' }: Props) {
    let options = required
        ? Object.values(Msi).map((city: any) => ({ label: translate(city), value: city }))
        : [{ label: '', value: null }, ...Object.values(Msi).map((city: any) => ({ label: translate(city), value: city }))];
    return (
        <FormSelect
            name={name}
            label={label}
            placeholder={placeholder}
            helperText={helperText}
            defaultValue={defaultValue}
            options={options}
            disabled={disabled}
            required={required}
            variant={variant}
        />
    );
}

type Props = {|
    name: string,
    label?: string,
    placeholder?: string,
    helperText?: string,
    defaultValue?: string,
    disabled?: boolean,
    required?: boolean | { value: number, message: string },
    variant?: Variant,
|};
